import { AddMemberType, EditMemberType, DeleteMemberType, IEditDirectorsID } from "./types";

export const addMemberSlr = (state: any): AddMemberType => state.fundDetails.fund.members.addMember;
export const editMemberSlr = (state: any): EditMemberType => state.fundDetails.fund.members.editMember;
export const deleteMemberSlr = (state: any): DeleteMemberType => state.fundDetails.fund.members.deleteMember;
export const editDirectorIDSlr = (state: any): IEditDirectorsID => state.fundDetails.fund.members.editDirectorID;
